import { Component, OnInit, OnDestroy, NgZone, EventEmitter, ViewChild } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap/modal';

import { Subscription } from 'rxjs';



import {
	AuthorizationService,
	ToastrService,
	Company,
	Minesite,
	CompanyService,
	UserService,
	MinesiteService,
	Permission
} from './../../../shared/index';

@Component({
    selector: 'user-filter',
    templateUrl: './user-filter.html',
    standalone: false
})

export class UserFilterComponent implements OnInit, OnDestroy {
	@ViewChild('userFilter') userFilter: ModalDirective;

	private subscriptions: Subscription[] = [];

	public minesites: Minesite[] = [];
	public companies: Company[] = [];
	public filteredMinesites: Minesite[];
	public selectedMinesites: number[] = [];
	public selectedCompanies: number[] = [];
	public selectedPermissions: number[] = [];

	public permissions: Permission[] = [];

	public filterApplied = false;
	public allEmployees = true;
    public name = '';
    public ableToPrint = true;
	public notAbleToPrint = true;
	public companyfilterApplied = false;

	constructor(
		private _ngZone: NgZone,
		private _companyService: CompanyService,
		private _minesiteService: MinesiteService,
		private _userService: UserService,
		private _toastrService: ToastrService
	) {
		this.subscriptions.push(this._minesiteService.minesitesChange.subscribe((info: any) => {
			this._ngZone.run(() => {
				this.minesites = info;
				this.filteredMinesites = this.minesites;
			});
		}));
		this.subscriptions.push(this._companyService.companysChange.subscribe((info: any) => {
			this._ngZone.run(() => {
				if (info.companies.length > 0) {
					const newCompanies = info.companies.filter(
						(incoming: Company) => !this.companies.some(existing => existing.Id === incoming.Id)
					);
					this.companies = [...this.companies, ...newCompanies];
				}
			});
		}));

		this.subscriptions.push(this._userService.permissionChange.subscribe((info: any) => {
			this._ngZone.run(() => {
				this.permissions = info;
			});
		}));
	}

	ngOnInit(): void {
		this._companyService.getCompanies();
		this._minesiteService.getMinesites();
		this._userService.getPermissions();
	}

	ngOnDestroy(): void {
		for (const subscription of this.subscriptions) {
			subscription.unsubscribe();
		}
	}

	public showFilters(): void {
		this.userFilter.show();
	}

	public applyFilter(): void {
		if (this.name != '' || this.allEmployees == false || this.selectedCompanies.length > 0 || this.selectedMinesites.length > 0 || this.selectedPermissions.length > 0 || (this.ableToPrint == true && this.notAbleToPrint == false) || (this.ableToPrint == false && this.notAbleToPrint == true)) {
			this.filterApplied = true;
		} else {
			this.filterApplied = false;
		}
		this._userService.applyFilter(this.name, this.allEmployees, this.selectedCompanies, this.selectedMinesites, this.selectedPermissions, this.ableToPrint, this.notAbleToPrint);
		this.userFilter.hide();
	}

	public employeePermissionIncluded(): boolean {
		return this.selectedPermissions.length == 0 || this.selectedPermissions.filter(permId => permId == 2).length > 0;
	}

	public clearFilter(): void {
		this.name = '';
		this.allEmployees = true;
		this.selectedMinesites = [];
		this.selectedCompanies = [];
		this.selectedPermissions = [];
        this.filterApplied = false;
        this.ableToPrint = true;
		this.notAbleToPrint = true;
		this.filteredMinesites = this.minesites;
        this._userService.applyFilter(this.name, this.allEmployees, this.selectedCompanies, this.selectedMinesites, this.selectedPermissions, this.ableToPrint, this.notAbleToPrint);
		this.companyfilterApplied = false;
	}

	public getselectedvalue(): void{
		this.companyfilterApplied = true;
		this._userService.filterMinesitesFor(this.selectedCompanies).then(value => {
			this.filteredMinesites = [];
			for (const minesite of this.minesites) {
				const index = value.indexOf(minesite.Id);
				if (index >= 0) {
					this.filteredMinesites.push(minesite);
				}
			}
		});
	}

	public clearCompanyFilter(): void {
		this.selectedCompanies = [];
		this.selectedMinesites = [];
		this.filteredMinesites = this.minesites;
		this.companyfilterApplied = false;
	}
}
